import {IS_VISITED_FINISH} from "../constants/constants";

export const isVisitedFinish = () => {
    return{
        type : IS_VISITED_FINISH,
    };
};


// WEBPACK FOOTER //
// ./src/actions/isVisitedFinish.js